export const defaultFraming = { fit: 'cover', zoom: 1, x: 50, y: 50, background: '#071827' };
export function parseFraming(value) {
  try {
    const f = typeof value === 'string' ? JSON.parse(value) : value;
    const number = (v, fallback, min, max) => Number.isFinite(v) ? Math.max(min, Math.min(max, v)) : fallback;
    return { fit: f?.fit === 'contain' ? 'contain' : 'cover', zoom: number(f?.zoom, 1, 0.25, 3),
      x: number(f?.x, 50, 0, 100), y: number(f?.y, 50, 0, 100),
      background: /^#[0-9a-f]{6}$/i.test(f?.background) ? f.background : defaultFraming.background };
  } catch { return { ...defaultFraming }; }
}
export function bannerImageStyle(value) {
  const f = parseFraming(value);
  const effectiveFit = f.fit === 'cover' && f.zoom < 1 ? 'contain' : f.fit;
  return { objectFit: effectiveFit, objectPosition: `${f.x}% ${f.y}%`, transform: `scale(${f.zoom})`, transformOrigin: `${f.x}% ${f.y}%` };
}
